import { BaseApi } from './base.api.js';

export class CookieInventoryApi extends BaseApi {
    constructor(client) {
        super(client, '/cookie-inventory');
    }
}
